import { useState, useCallback } from 'react';
import useLab2PageState from 'features/lab2/hooks/useLab2PageState';

const DEFAULT_AGE = 'all';

export default function usePopulationAppState() {
    const labState = useLab2PageState();
    const [currentAge, setCurrentAge] = useState(DEFAULT_AGE);
    const [lineLayerVisible, setLineLayerVisible] = useState(false);

    const searchPopulation = useCallback((age) => {
        setCurrentAge(age);
    }, []);

    const resetFeature = useCallback(() => {
        setLineLayerVisible(false);
    }, []);

    return {
        ...labState,
        currentAge,
        setCurrentAge,
        lineLayerVisible,
        setLineLayerVisible,
        searchPopulation,
        resetFeature,
    };
}
